import axios, { CancelToken } from 'axios';
import { getToken } from "../../../token";
import { urlHttpGov } from "../../../request/urls";
import { IWhatsAppMensagens } from '../../../../pages/WhatsAppMensagens/interface';

class WhatsAppMensagensService {
    async getMensagens(signal?: CancelToken): Promise<Array<IWhatsAppMensagens>> {
        const { data } = await axios.get(`${urlHttpGov}/whatsapp/mensagens`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    getMensagensAbertas(signal?: CancelToken) {
        return axios.get(`${urlHttpGov}/whatsapp/mensagens/abertas`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        }).then(({ data }) => data);
    }

    async putStatusMensagem(idStatus: string, signal?: CancelToken) {
        const { data } = await axios.put(`${urlHttpGov}/whatsapp/mensagens/`,
            {
                id: idStatus,
            },
            {
                cancelToken: signal,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                },
            }
        );
        return data
    }
}

export default new WhatsAppMensagensService();
